import React from "react";

function Footer() {
  return (
    <>
      <div class='footer'>
        <p>
          copyright © <a href='https://github.com/singh-riya'> Riya Singh</a>{" "}
        </p>
      </div>
    </>
  );
}

export default Footer;
